/**
 * A moldura do aplicativo: barra de estado em cima, tela no meio, navegacao em
 * baixo. Tudo o que e permanente vive aqui; tudo o que muda entra pelo <Outlet>.
 */
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Banner } from '@flos/ui';
import { useApp } from '../state/AppContext';
import { buildNavItems, SHELL_PATHS } from '../navigation';
import { BottomNav } from './BottomNav';
import { SyncIndicator } from './SyncIndicator';
import { UpdatePrompt } from './UpdatePrompt';
import { useServiceWorkerUpdate } from '../pwa/useServiceWorkerUpdate';

export function AppShell() {
  const { boot, manifests, sync, readOnly } = useApp();
  const navigate = useNavigate();
  const location = useLocation();
  const update = useServiceWorkerUpdate();

  const items = buildNavItems({
    routes: boot.core.registry.routes(),
    manifests,
    conflicts: sync.conflicts,
  });

  return (
    <div className="app-shell">
      <div className="app-statusbar">
        <span className="app-statusbar__brand">Vida em Família</span>
        <SyncIndicator
          status={sync}
          onOpenConflicts={() => navigate(SHELL_PATHS.CONFLICTS)}
        />
      </div>

      {readOnly ? (
        <div className="app-statusbar__notice">
          <Banner tone="warning" title={readOnly.title}>
            {readOnly.message}
          </Banner>
        </div>
      ) : null}

      <div className="app-body" key={location.pathname}>
        <Outlet />
      </div>

      <UpdatePrompt
        visible={update.updateReady}
        onUpdate={update.applyUpdate}
        onDismiss={update.dismiss}
      />

      <BottomNav items={items} />
    </div>
  );
}
